module.exports = __webpack_public_path__ + "static/img/zhong2.9734447.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/zhong2.jpeg
// module id = BGOt
// module chunks = 0